


































































































































































































































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {$, Collection} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {UploadConfig} from '@/config/upload.config'
import CargaRequest from '@/model/request/CargaRequest'
import Carga from '@/model/resource/Carga'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import {ItrackCollection} from '@/helpers'
import * as Helper from '@/helpers'
import {FileFormat} from '@/enums/FileFormat'
import ItUpload from '@/components/itrack/ItUpload.vue'
import TipoOcorrenciaSucesso from '@/model/resource/TipoOcorrenciaSucesso'
import {CargaInfo} from '@/model/resource/CargaInfo'

enum State {
  STEP1,
  STEP2,
}

enum Action {
  NO_OCCURRENCE = 1,
  OCCURENCE = 2,
  RETURNED = 3,
}

enum DriverType {
  OWN = 1,
  OTHER = 2,
  UNDEFINED = 3,
}

enum DocType {
  CPF = 1,
  CNPJ = 2,
  RG = 3,
}

enum UploadState {
  RECEIPT = 1,
  OCCURRENCE = 2,
}

@Component
export default class ModalDeliveryEnd extends Vue {
  AppConfig = AppConfig
  UploadConfig = UploadConfig
  State = State
  Action = Action
  DriverType = DriverType
  DocType = DocType
  UploadState = UploadState
  FileFormat = FileFormat
  Helper = Helper

  model = new Carga()
  cargaInfo = new CargaInfo()
  collection = new Collection(Carga)

  allTipoOcorrencia = ItrackCollection.allTipoOcorrenciaEnd
  allTipoOcorrenciaSucesso = ItrackCollection.allTipoOcorrenciaSucessoEnd
  tipoOcorrenciaNaoDevolvidaCollection = new Collection(TipoOcorrencia)
  tipoOcorrenciaDevolvidaCollection = new Collection(TipoOcorrencia)

  state = State.STEP1
  action: Action | null = null

  driverType: DriverType | null = null
  docType: DocType | null = null
  uploadState: UploadState | null = null

  uploadInProgress = false
  openOccurrenceAfterUpload = false
  finishAfterUpload = false
  endingInProgress = false

  @Watch('driverType')
  async driverTypeEvent(val: DriverType) {
    if (val === DriverType.OWN) {
      const item = this.collection.items[0]

      const name = item.destinatario.$tag
      const doc = item.destinatario.cpfCnpj

      if (doc.length > 11) {
        this.docType = DocType.CNPJ
      } else {
        this.docType = DocType.CPF
      }

      await this.$nextTick()

      this.model.nomeRecebedor = name
      this.model.documentoRecebedor = doc
    } else {
      this.model.nomeRecebedor = null
      this.model.rgRecebedor = null
      this.model.documentoRecebedor = null
      this.docType = null
    }
  }

  @Watch('docType')
  docTypeEvent() {
    this.model.documentoRecebedor = null
    this.model.rgRecebedor = null
  }

  openSendOcurrence() {
    // @ts-ignore
    const ituploadComprovantes = this.$refs.ituploadComprovantes as ItUpload

    if (ituploadComprovantes && ituploadComprovantes.files.length) {
      this.openOccurrenceAfterUpload = true
      ituploadComprovantes.send()
      return
    }

    this.openOccurrenceAfterUpload = false
    this.uploadState = UploadState.OCCURRENCE
  }

  async receiptUploadEvent(urls: string[]) {
    this.uploadState = null
    this.uploadInProgress = false
    if (this.openOccurrenceAfterUpload) {
      this.openSendOcurrence()
    } else if (this.finishAfterUpload) {
      await this.end(true)
    }
  }

  async occurrenceUploadEvent(urls: string[]) {
    this.uploadState = null
    this.uploadInProgress = false
    if (this.finishAfterUpload) {
      await this.end(true)
    }
  }

  startUploadEvent() {
    this.uploadInProgress = true
  }

  cancelUploadEvent() {
    this.uploadInProgress = false
    this.uploadState = null
  }

  get isFinalizeDisabled() {
    return this.uploadInProgress || this.endingInProgress
  }

  get tipoOcorrenciaCollection() {
    if (this.action === Action.RETURNED) {
      return this.tipoOcorrenciaDevolvidaCollection
    }
    return this.tipoOcorrenciaNaoDevolvidaCollection
  }

  get tipoOcorrenciaResource() {
    return this.model.tipoOcorrencia
  }
  set tipoOcorrenciaResource(val: TipoOcorrencia | null) {
    this.model.tipoOcorrencia = val ? this.tipoOcorrenciaCollection.get(val.$id) : null
  }

  get tipoOcorrenciaSucessoResource() {
    return this.cargaInfo.tipoOcorrenciaSucesso
  }
  set tipoOcorrenciaSucessoResource(val: TipoOcorrenciaSucesso | null) {
    this.cargaInfo.tipoOcorrenciaSucesso = val ? this.allTipoOcorrenciaSucesso.get(val.$id) : null
  }

  async end(skipLock = false) {
    if (!skipLock) {
      if (this.endingInProgress) {
        return
      }
      this.endingInProgress = true
    }

    // @ts-ignore
    const ituploadComprovantes = this.$refs.ituploadComprovantes as ItUpload

    // @ts-ignore
    const ituploadOcorrencias = this.$refs.ituploadOcorrencias as ItUpload

    try {
      if (ituploadComprovantes && ituploadComprovantes.files.length) {
        this.finishAfterUpload = true
        await ituploadComprovantes.send()
        return
      }

      if (ituploadOcorrencias && ituploadOcorrencias.files.length) {
        this.finishAfterUpload = true
        await ituploadOcorrencias.send()
        return
      }

      this.finishAfterUpload = false

      // const uploadsValid = await this.validateUploadsBeforeFinish()
      // if (!uploadsValid) {
      //   return
      // }

      this.model.cargaInfo = this.cargaInfo

      this.populateCollection()

      const request = new CargaRequest()
      request.items = this.collection.items

      await Carga.finalizarCargaEmLote(request as CargaRequest, 'cargaInProgress')

      this.$emit('end')
      Helper.success('system.success.finish')
      this.close()
    } finally {
      if (skipLock || !this.finishAfterUpload) {
        this.endingInProgress = false
      }
    }
  }

  async validateUploadsBeforeFinish() {
    const receiptsValid = await this.validateUploadedUrls(
      this.model.fotosComprovantes,
      UploadState.RECEIPT,
      this.$t('modal.deliveryEnd.form.receipts') as string,
    )

    const occurrencesValid = await this.validateUploadedUrls(
      this.model.fotosOcorrencia,
      UploadState.OCCURRENCE,
      this.$t('modal.deliveryEnd.form.occurrence') as string,
    )

    return receiptsValid && occurrencesValid
  }

  async validateUploadedUrls(urls: string[] | null | undefined, uploadStateToOpen: UploadState, label: string) {
    if (!urls || !urls.length) {
      return true
    }

    const invalidUrls: string[] = []

    await Promise.all(urls.map(async (url) => {
      try {
        const response = await ($.http as any).head(url, { timeout: 4000 })
        const statusOk = response.status >= 200 && response.status < 400
        const sizeHeader = Number(response.headers['content-length'])
        const hasSizeInfo = Number.isNaN(sizeHeader) || sizeHeader > 0

        if (!statusOk || !hasSizeInfo) {
          invalidUrls.push(url)
        }
      } catch (e) {
        invalidUrls.push(url)
      }
    }))

    if (invalidUrls.length) {
      const invalidSet = new Set(invalidUrls)
      const filteredUrls = urls.filter((url) => !invalidSet.has(url))
      if (uploadStateToOpen === UploadState.RECEIPT) {
        this.model.fotosComprovantes = filteredUrls
      } else if (uploadStateToOpen === UploadState.OCCURRENCE) {
        this.model.fotosOcorrencia = filteredUrls
      }

      this.uploadState = uploadStateToOpen
      Helper.error(`${label}: Failed to validate the uploaded files. Please upload them again.`)
      return false
    }

    return true
  }

  populateCollection() {
    const {model} = this

    this.collection.items.forEach((item) => {
      item.nomeRecebedor = model.nomeRecebedor
      item.documentoRecebedor = model.documentoRecebedor
      item.rgRecebedor = model.rgRecebedor
      item.dataFinalizacao = model.dataFinalizacao
      item.codigoBarra = model.codigoBarra
      item.qtdPaleteEntregue = model.qtdPaleteEntregue
      item.qtdPaleteRetirado = model.qtdPaleteRetirado
      item.fotosComprovantes = model.fotosComprovantes
      item.fotosOcorrencia = model.fotosOcorrencia
      item.tipoOcorrencia = model.tipoOcorrencia
      item.observacao = model.observacao || null
      item.devolvida = model.devolvida
      item.cargaInfo = model.cargaInfo
    })
  }

  endAsNoOccurrence() {
    this.action = Action.NO_OCCURRENCE
    this.state = State.STEP2
    this.model.devolvida = null
    this.model.dataFinalizacao = null;
    this.model.dataBaixaSistema = Helper.now().format()
  }

  endAsOccurrence() {
    this.action = Action.OCCURENCE
    this.state = State.STEP2
    this.model.devolvida = false
    this.model.dataFinalizacao = null;
    this.model.dataBaixaSistema = Helper.now().format()
  }

  endAsReturned() {
    this.action = Action.RETURNED
    this.state = State.STEP2
    this.model.devolvida = true
    this.model.dataFinalizacao = null;
    this.model.dataBaixaSistema = Helper.now().format()
  }

  close() {
    this.$modal.close('deliveryEnd')
  }

  reset() {
    this.model = new Carga()
    this.collection.items = []
    this.state = State.STEP1
    this.action = null
    this.driverType = null
    this.docType = null
    this.uploadState = null
    this.uploadInProgress = false
    this.openOccurrenceAfterUpload = false
    this.finishAfterUpload = false
    this.endingInProgress = false
    this.cargaInfo.tipoOcorrenciaSucesso = null
  }

  async openEvent(selectedItems: Carga[]) {
    this.$emit('open')
    this.reset()
    this.collection.items = selectedItems

    await this.allTipoOcorrencia.query()
    await this.allTipoOcorrenciaSucesso.query(null, 'getTipoSucesso')

    const filterNaoDevolvida = this.allTipoOcorrencia.items.filter((item) => !item.ehDevolvida)
    const filterDevolvida = this.allTipoOcorrencia.items.filter((item) => !!item.ehDevolvida)

    this.tipoOcorrenciaNaoDevolvidaCollection = Helper.collect(TipoOcorrencia, filterNaoDevolvida)
    this.tipoOcorrenciaDevolvidaCollection = Helper.collect(TipoOcorrencia, filterDevolvida)
  }

  closeEvent() {
    this.$emit('close')
    this.reset()
  }

  get showFinalizacaoSucesso() {
    return this.action === Action.NO_OCCURRENCE &&
        Helper.getPermitirTipoFinalizacaoSucesso() && this.allTipoOcorrenciaSucesso.total > 0
  }
}
